import React, { Fragment, PureComponent } from 'react';
import { AnalyticDataSources } from '~/Api/Analytics/VirtualBrand/mapAnalyticVirtualBrand';
import Country from '~/Api/Country/Country';
import Icon from '~/UI/Icon';
import Tooltip from '~/UI/Tooltip';

import styles from './styles.less';

type AvailabilityData = { [countryCode: string]: AnalyticDataSources };

interface Props {
	countries: Country[];
	availability: AvailabilityData;
	invertColors: boolean;
}

export default class Availability extends PureComponent<Props> {
	static defaultProps = {
		invertColors: false,
	};

	renderAvailability(availability: AvailabilityData) {
		const { countries } = this.props;
		return String(countries.reduce((result, country) => result + (availability[country.alpha2] ? 1 : 0), 0));
	}

	renderTooltip() {
		const { countries, availability, invertColors } = this.props;
		const availableCountries = countries.filter((country) => Boolean(availability[country.alpha2]));

		return (
			<Tooltip reference={<Icon name={invertColors ? 'white-question-mark' : 'violet-question-mark'} />}>
				{availableCountries.length > 0 ? (
					<ul className={styles.list}>
						{availableCountries.map((country) => (
							<li className={styles.listItem} key={country.alpha2}>
								{country.name}
							</li>
						))}
					</ul>
				) : (
					<p className={styles.text}>Not available in this region</p>
				)}
			</Tooltip>
		);
	}

	render() {
		const { countries, availability } = this.props;

		return (
			<Fragment>
				<div className={styles.count}>
					{this.renderAvailability(availability)}
					&nbsp;/&nbsp;
					{countries.length}
				</div>
				{this.renderTooltip()}
			</Fragment>
		);
	}
}
